import validate from 'validate.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { docToDataObject } from 'helpers'
import { useTEPopupsFunctions } from 'react-tec'
import { RouteComponentProps } from 'react-router'

interface Data {
	email: string
	password: string
	history: RouteComponentProps['history']
	fromPath?: string
	popupFunctions: useTEPopupsFunctions
}
export const signInUser = async (data: Data) => {
	const { email, password, history, fromPath, popupFunctions } = data
	const { showAlert, showNetworkActivity, hideNetworkActivity } = popupFunctions

	//Validate Data
	const validatorConstraints: { [key: string]: any } = {
		email: {
			presence: {
				allowEmpty: false,
			},
			email: true,
		},
		password: {
			presence: {
				allowEmpty: false,
			},
		},
	}
	const validationResponse = validate(data, validatorConstraints)
	if (validationResponse) {
		const valuesArray: any[][] = Object.values(validationResponse)
		const firstError: any[] = valuesArray[0]
		const firstErrorMessage: string = firstError[0]
		showAlert({
			title: 'Error',
			message: firstErrorMessage,
		})
		return
	}

	try {
		showNetworkActivity('Signing In...')
		const firebaseAuth = firebase.auth()
		await firebaseAuth.signInWithEmailAndPassword(email, password)
		//This could be better
		const { uid } = firebaseAuth.currentUser!
		const userModelSnapshot = await firebase.firestore().collection('Users').doc(uid).get()
		const userModel = docToDataObject(userModelSnapshot)
		switch (userModel.user_type) {
			case 'admin':
				hideNetworkActivity()
				history.push(fromPath ?? '/admin/companies')
				return
			case 'employee':
				hideNetworkActivity()
				history.push(fromPath ?? '/portal/dashboard')
				return
			default:
				firebase.auth().signOut()
				hideNetworkActivity()
				showAlert({
					title: 'Error Signing In',
					message:
						'This account is missing user permissions. If this is happening in error please reach out to support@rcmssoftware.com',
				})
				return
		}
	} catch (e) {
		console.log(e)
		hideNetworkActivity()
		showAlert({
			title: 'Error',
			message: 'Error Signing In',
		})
		return
	}
}
